import { evaluationStageType } from "../Models/EvaluationStageType"

export interface QuestionType {
    id: number
    text: string
}

export type questionArrType = "light" | "full";

//This Array contains the Questions for rendering on QuestionsPage.
export const questionsObj = {
    light: [
        {
            id:1,
            text:"evaluationTool.evaluationQuestion.questionBeforeAfter"
        }
    ],
    full: [
        {
            id: 1,
            text: "evaluationTool.evaluationQuestion.questionsFull.question1"
        },
        {
            id: 2,
            text: "evaluationTool.evaluationQuestion.questionsFull.question2"
        },
        {
            id: 3,
            text: "evaluationTool.evaluationQuestion.questionsFull.question3"
        }
    ]
}

//Function for finding the .text for a specific question inside the array
export const setQuestion = (question: number | string, arrayKey: evaluationStageType, polyglot:any ) => {
    let questionsArrToRender: questionArrType;
    questionsArrToRender = arrayKey === "beforeLight" || arrayKey === "afterLight" ? "light" : "full";

    if (typeof question === "number") {
        const found = questionsObj[questionsArrToRender].find((q) => q.id === question)
        return polyglot.t(found?.text)
    } else {
        return polyglot.t(question)
    }
}
